// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========

import { updateDisabledServices } from '@/lib/edition';
import { productFetch } from '@/lib/products/productFetch';

/**
 * Applies the admin's list of switched-off services. A failed request leaves
 * the build and runtime defaults in place.
 */
export async function loadServiceVisibility(): Promise<void> {
  try {
    const res = await productFetch('/api/service-visibility');
    if (!res.ok) return;
    const data = (await res.json()) as { disabled_services?: unknown };
    if (Array.isArray(data?.disabled_services)) {
      updateDisabledServices(
        data.disabled_services.filter((k): k is string => typeof k === 'string')
      );
    }
  } catch {
    // Defaults remain.
  }
}
